import { ChangeDetectionStrategy, Component, computed, input, InputSignal } from '@angular/core';
import { Router } from '@angular/router';

import {
    ActionItem,
    ApiFragment,
    BaseContainer,
    Face,
    GetRecordFaces,
    ViewerActionsPosition
} from '@stylehaven/components';

@Component({
    standalone: false,
    selector: 'med-fragment-preview',
    templateUrl: './fragment-preview.component.html',
    styleUrls: ['./fragment-preview.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FragmentPreviewComponent extends BaseContainer {
    public readonly ViewerActionsPosition: typeof ViewerActionsPosition = ViewerActionsPosition;

    public record: InputSignal<ApiFragment | undefined> = input();
    public allowFullscreen: InputSignal<boolean> = input(true);

    public $isPlayableMedia = computed(() => this.record()?.isPlayableMedia());
    public $recordTitle = computed(() => this.record()?.getTitle());
    public $recordPreviewUrl = computed(() => this.record()?.getImagePreviewUrl());
    public $recordFaces = computed(() => this.getFaces(this.record()));

    public $allowTransform = computed(
        () => !(this.record()?.doesNotHaveBrowse() || this.record()?.hasIncompleteBrowse())
    );

    public $customActionItems = computed(() => this.getCustomActionItems(this.allowFullscreen()));

    constructor(private readonly router: Router) {
        super();
    }

    public showFullscreen(): void {
        const currentUrl = this.router.url.split('(')[0]; // Get URL without outlets
        this.router.navigateByUrl(currentUrl + '/(preview:preview)');
    }

    private getFaces(record: ApiFragment | undefined): Face[] {
        return record ? GetRecordFaces(record) : [];
    }

    private getCustomActionItems(allowFullscreen: boolean): ActionItem[] {
        return allowFullscreen
            ? [
                  {
                      label: this.translateService.translate('fragments.show-bigger'),
                      icon: 'expand',
                      eventListener: () => this.showFullscreen()
                  }
              ]
            : [];
    }
}
